module.exports = __webpack_public_path__ + "img/IMG_1149_L_WoodMatted.7e88c1bd.jpg";